import React from 'react';

const HeaderRow = ({ onSort, sortField, sortDirection }) => {
  const sortIcon = (field) => {
    if (sortField !== field) return <span className="sort-icon">↕</span>;
    return <span className="sort-icon active">{sortDirection === 'asc' ? '↑' : '↓'}</span>;
  };

  const handleSort = (field) => {
    onSort(field, sortField === field && sortDirection === 'asc' ? 'desc' : 'asc');
  };

  return (
    <div className="product-header">
      <div className="col col-name sortable" onClick={() => handleSort('flavor')}>
        Product {sortIcon('flavor')}
      </div>
      <div className="col col-cogs sortable" onClick={() => handleSort('total_cogs')}>
        Total COGS {sortIcon('total_cogs')}
      </div>
      <div className="col col-margin sortable" onClick={() => handleSort('wholesale_margin')}>
        W/Sale % {sortIcon('wholesale_margin')}
      </div>
      <div className="col col-retail-margin sortable" onClick={() => handleSort('retail_margin')}>
        Retail % {sortIcon('retail_margin')}
      </div>
      <div className="col col-status sortable" onClick={() => handleSort('is_active')}>
        Status {sortIcon('is_active')}
      </div>
      <div className="col col-actions" />
    </div>
  );
};

export default HeaderRow;
